import script from "./SectionRegulations.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionRegulations.vue?vue&type=script&setup=true&lang=js"

import "./SectionRegulations.vue?vue&type=style&index=0&id=3e6f99b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6f99b7"]])

export default __exports__